// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserAttributeTab_wrapper__B60r","manageAttributeButton":"UserAttributeTab_manageAttributeButton_2JSp9","buttonControl":"UserAttributeTab_buttonControl_1-NXY"};